import apiService from '@/api/apiService';

export const userList = async (pageSize, pageIndex, searchParams = {}) => {
    const url = '/api/admin/users';

    // 建立所有查詢參數的物件
    const queryParams = {
        page: pageIndex,
        page_size: pageSize,
        ...(searchParams.name && { name: searchParams.name }),
        ...(searchParams.email && { email: searchParams.email })
    };

    // 將物件轉換為 URL 參數
    const params = new URLSearchParams(queryParams);

    const response = await apiService.GET(`${url}?${params.toString()}`);

    // API 已統一為格式 A：{ status: 1, data: [...], page, page_size, total }
    // 直接回傳，前端統一使用 response.data 取得資料陣列
    return response;
}; 